/* Editorial sunlight and a shared stage. Inspired by React Bits Light Rays and Split Text. */
(() => {
  'use strict';
  let dispose=()=>{};
  const entered=new WeakSet();
  function init(){
    dispose();
    const hero=document.querySelector('.vxh-hero'), wrapper=document.querySelector('.page-wrapper');
    if(!hero||!wrapper)return;
    const reduced=matchMedia('(prefers-reduced-motion: reduce)');
    const desktop=matchMedia('(min-width:990px)');
    let clean=[],frame=0,visible=true;
    const on=(el,event,fn,options)=>{el.addEventListener(event,fn,options);clean.push(()=>el.removeEventListener(event,fn,options));};
    const active=()=>!reduced.matches&&!document.hidden&&!window.Shopify?.designMode;
    let light=hero.querySelector('.vx3-sunlight');
    if(!light){light=document.createElement('div');light.className='vx3-sunlight';light.setAttribute('aria-hidden','true');hero.prepend(light);}
    const photo=hero.querySelector('.vxh-hero-visual');
    const measure=()=>{
      const r=hero.getBoundingClientRect(), w=wrapper.getBoundingClientRect();
      const scroll=desktop.matches?wrapper.scrollTop:0;
      wrapper.style.setProperty('--vx3-stage-height',`${Math.round(r.bottom-w.top+scroll+20)}px`);
    };
    const update=()=>{
      frame=0;if(!visible||!photo)return;
      const r=hero.getBoundingClientRect();
      const progress=active()&&desktop.matches?Math.max(0,Math.min(1,-r.top/r.height)):0;
      photo.style.setProperty('--vx3-image-y',`${-progress*28}px`);
      photo.style.setProperty('--vx3-photo-y',`${progress*16}px`);
    };
    const scroll=()=>{if(!frame&&visible&&active())frame=requestAnimationFrame(update);};
    on(wrapper,'scroll',scroll,{passive:true});on(window,'scroll',scroll,{passive:true});
    on(window,'resize',()=>{measure();update();},{passive:true});
    on(reduced,'change',update);on(desktop,'change',()=>{measure();update();});
    on(document,'visibilitychange',()=>{if(document.hidden){cancelAnimationFrame(frame);frame=0;}else update();});
    if('ResizeObserver' in window){const ro=new ResizeObserver(measure);ro.observe(hero);const header=document.querySelector('#header-group');if(header)ro.observe(header);clean.push(()=>ro.disconnect());}
    if('IntersectionObserver' in window){const io=new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;hero.dataset.vx3Visible=String(visible);if(visible)update();},{threshold:0});io.observe(hero);clean.push(()=>io.disconnect());}else hero.dataset.vx3Visible='true';
    if(photo&&active()&&!entered.has(photo)&&photo.animate){
      entered.add(photo);
      const a=photo.animate([{clipPath:'inset(8% 9% 8% 9% round 4px 36% 4px 4px)',opacity:.55},{clipPath:'inset(0% 0% 0% 0% round 4px 0% 4px 4px)',opacity:1}],{duration:1450,easing:'cubic-bezier(.16,1,.3,1)'});
      clean.push(()=>a.cancel());
    }
    measure();update();
    dispose=()=>{clean.forEach(fn=>fn());cancelAnimationFrame(frame);};
  }
  document.addEventListener('shopify:section:load',init);
  document.addEventListener('shopify:section:unload',init);
  init();
})();
